// Load all controllers from this directory and all subdirectories.
// Controller files must be named *_controller.js (or controller.js for component-co-located primary controllers).

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

const application = Application.start()

// Auto-register all *_controller.js files in the controllers/ directory tree
const context = require.context("./", true, /_controller\.js$/)
application.load(definitionsFromContext(context))

// Auto-register controllers co-located with ViewComponents.
//   <folder>/controller.js        -> folder path        (e.g. timers--tick)
//   <folder>/<name>_controller.js -> folder path + name (e.g. timers--tick--clock)
const componentContext = require.context("../../components", true, /_controller\.js$|\/controller\.js$/)
componentContext.keys().forEach((key) => {
  const path = key.replace(/^\.\//, "").replace(/\.js$/, "")
  const logical = path.endsWith("/controller")
    ? path.slice(0, -"/controller".length)
    : path.replace(/_controller$/, "")
  application.register(logical.replace(/_/g, "-").replace(/\//g, "--"), componentContext(key).default)
})

// npm-package controllers (cannot be auto-discovered by filename glob)
import Flatpickr from 'stimulus-flatpickr'
application.register('flatpickr', Flatpickr)

import Chartjs from '@stimulus-components/chartjs'
application.register('chartjs', Chartjs)
